export const showellNavHeight = '70px';

// colors
export const darkgrey = '#151515';
// export const grayLight = '#F8F8F8';
// export const grayDark = '#696969';
export const yellow = '#ffe538';
// export const yellowLight = '#FFFCDF';
// export const green = '#538D25';
// export const blue = '#157FA9';
